import { createContext } from 'react';

const FeedEditorContext = createContext( null );

export default FeedEditorContext;